<template>
  <!-- 投資型基本輸入：版型二　定期繳+彈性繳VUL -->
  <div>
    <div class="row mt_16">
      <div class="col create_title">規劃保費與保額</div>
    </div>
    <!-- 保費 -->
    <div class="form-group d-flex align-items-end mt_20">
      <div class="d-flex text-norwap mr_8">
        <strong style="line-height: 40px">目標保費:</strong>
      </div>
      <div class="d-flex align-items-center mr_8">
        <!-- 繳別 -->
        <label>繳別:</label>
        <select
          class="form-control"
          style="width: 8rem"
          :id="'pay_freq'"
          data-vv-name="pay_freq"
          :class="{ 'is-invalid': errors.has('pay_freq') }"
          v-validate="`required`"
          data-vv-as="繳別"
          v-model="productDataScope.pay_freq"
          @change="getINVAmtLimitRanges()"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(payFreqOption, index) in option.payFreq_option"
            :key="index.paraval"
            :value="payFreqOption.paraval"
          >
            {{ payFreqOption.paradetlno }}
          </option>
        </select>
      </div>
      <div class="d-flex align-items-center mr_8">
        <!-- 繳別 -->
        <label>繳至:</label>
        <input
          type="tel"
          maxlength="2"
          class="form-control mr_2"
          style="width: 7rem"
          :id="'pol_endage'"
          :data-vv-name="'pol_endage'"
          :class="{ 'is-invalid': errors.has('pol_endage') }"
          v-validate="`required|pol_endage`"
          data-vv-as="繳至"
          @input="
            ageFormat(productDataScope, 'pol_endage');
            resetPaymethod('pol_endage');
          "
          v-model.trim="productDataScope.pol_endage"
        />歲
      </div>

      <!-- 每期保費 -->
      <div class="d-flex align-items-center">
        <div style="line-height: 40px" class="mr_4">每期保費:</div>
        <div class="position-relative">
          <div class="notice-top text-red">
            {{
              `需以${formatMethods(
                PRODUCT_FEATURE_DATA.face_prem_incr_unit
              )}${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
            }}
          </div>
          <div class="d-flex align-items-center">
            <input
              type="tel"
              class="form-control mr_2"
              style="width: 175px"
              :class="{ 'is-invalid': errors.has('pol_premium') }"
              :id="'pol_premium'"
              :data-vv-name="'pol_premium'"
              v-validate.continues="{
                required: true,
                pol_premium: productDataScope.pol_premium,
              }"
              data-vv-as="每期保費"
              @input="
                numberHandler(productDataScope, 'pol_premium', $event);
                getINVAmtLimitRanges();
              "
              @blur="numberHandler(productDataScope, 'pol_premium', $event)"
              :value="productDataScope.pol_premium | formatMethods"
              @change="productDataScope.amt && $validator.validate(`amt`)"
              :placeholder="
                productDataScope.pay_freq &&
                prem_limit[productDataScope.pay_freq]
                  ? `${formatMethods(
                      converIncrUnit(
                        prem_limit[productDataScope.pay_freq].prem_floor
                      )
                    )}~${
                      prem_limit[productDataScope.pay_freq].prem_ceil < 0
                        ? '無上限'
                        : formatMethods(
                            converIncrUnit(
                              prem_limit[productDataScope.pay_freq].prem_ceil
                            )
                          )
                    }`
                  : ''
              "
            />
          </div>
        </div>
        <span>{{ currTranser(PRODUCT_FEATURE_DATA.curr, true) }}</span>
      </div>
    </div>
    <!-- 基本保額 -->
    <div class="form-group d-flex align-items-end mt_20">
      <div class="d-flex mr_8">
        <strong style="line-height: 40px">基本保額:</strong>
      </div>

      <div class="d-flex flex-column align-items-start">
        <div
          class="notice-top text-red"
          style="left: 20px; text-align: left"
          v-if="
            PRODUCT_FEATURE_DATA.amt_incr_unit !== '0' &&
            PRODUCT_FEATURE_DATA.amt_incr_unit / amt_formatVal != 1 &&
            !(
              PRODUCT_FEATURE_DATA.amt_unit == '7' ||
              PRODUCT_FEATURE_DATA.amt_unit == '8' ||
              PRODUCT_FEATURE_DATA.col_amt == '1'
            )
          "
        >
          {{
            `需以${formatMethods(
              PRODUCT_FEATURE_DATA.amt_incr_unit / amt_formatVal
            )}${
              PRODUCT_FEATURE_DATA.amt_unit_nm.indexOf("元") != -1
                ? ""
                : PRODUCT_FEATURE_DATA.amt_unit_nm
            }${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
          }}
        </div>
        <div class="d-flex align-items-center">
          <input
            type="tel"
            class="form-control mr_2"
            style="width: 10rem"
            :class="{ 'is-invalid': errors.has('amt') }"
            :id="'amt'"
            :data-vv-name="'amt'"
            v-validate.continues="{
              required: true,
              amt: productDataScope.amt,
            }"
            data-vv-as="基本保額"
            @input="
              numberHandler(productDataScope, 'amt', $event);
              resetPaymethod('amt');
            "
            @blur="numberHandler(productDataScope, 'amt', $event)"
            :value="productDataScope.amt | formatMethods"
            :placeholder="
              amt_limit
                ? `${formatMethods(amt_limit.amt_floor)}~${
                    amt_limit.amt_ceil <= 0
                      ? '無上限'
                      : formatMethods(amt_limit.amt_ceil)
                  }`
                : ''
            "
          />
          <span>{{
            unit_curr(PRODUCT_FEATURE_DATA.amt_unit, PRODUCT_FEATURE_DATA.curr)
          }}</span>
        </div>
      </div>
      <div class="col-8 align-items-center">
        <div class="yearPremiumLimit" v-if="yearPremiumLimit">
          基本保額的年繳化目標保費上下限:
          {{
            `${formatMethods(yearPremiumLimit.prem_floor)}
            ${currTranser(PRODUCT_FEATURE_DATA.curr, true)}~
            ${formatMethods(yearPremiumLimit.prem_ceil)}
            ${currTranser(PRODUCT_FEATURE_DATA.curr, true)}`
          }}
        </div>
      </div>
    </div>
    <input
      style="display: none"
      type="tel"
      :id="'insurer_actage'"
      data-vv-as="insurer_actage"
      :value="insurer_actage"
    />
    <!-- 新增繳費方式 -->
    <div class="position-relative d-inline-block mt_18">
      <div class="notice-top" style="bottom: 52px">非必要欄位，可不輸入</div>
      <a
        class="btn btn-default"
        style="line-height: 20px; height: 44px"
        @click="addPayMethods()"
      >
        調整基本保額/新增繳費方式
      </a>
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import { Validator } from "vee-validate";
import moment from "moment";
export default {
  props: ["productDataScope", "mainIndex", "option"],
  mixins: [mf_Mixin],
  data() {
    return {
      amt_limit: null,
      prem_limit: [{}, {}, {}, {}],
      getINVPremiumLimitTimer: null,
      getINVAmtLimitTimer: null,
      yearPremiumLimit: null,
      insurer_actage: this.$store.getters.MfEditing.insurer.insured_birthday
        ? moment().diff(
            moment(this.$store.getters.MfEditing.insurer.insured_birthday),
            "years"
          )
        : this.$store.getters.MfEditing.insurer.insured_age,
    };
  },
  computed: {
    PRODUCT_FEATURE_DATA() {
      return this.productDataScope.FEATURE_DATA;
    },
    amt_formatVal() {
      if (this.productDataScope.FEATURE_DATA.amt_unit == "") {
        return 1;
      } else {
        return this.$amtUnitFormat(this.productDataScope.FEATURE_DATA.amt_unit);
      }
    },
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    nowProduct() {
      return this.MfEditing.mc_prod_list[0];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async addPayMethods() {
      const checkResult = await this.$validator.validateAll();
      if (!checkResult) {
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤! ",
        });
      } else {
        this.productDataScope.pol_endage_tmp = this.productDataScope.pol_endage;
        this.productDataScope.amt_tmp = this.productDataScope.amt;
        this.$router.push("/mf/create/addPayment");
      }
    },
    init() {
      this.productDataScope.pol_endage_tmp = this.productDataScope.pol_endage;
      this.productDataScope.amt_tmp = this.productDataScope.amt;
      this.getINVLimitRanges();
      if (this.productDataScope.pol_premium && this.productDataScope.pay_freq) {
        this.getINVAmtLimitRanges();
      }
    },
    async getINVLimitRanges() {
      let insured_actage = this.MfEditing.insured.insured_birthday
        ? moment().diff(
            moment(this.MfEditing.insured.insured_birthday),
            "years"
          )
        : this.MfEditing.insured.insured_age;
      let {
        amt_limit,
        prem_limit,
      } = await this.$mfAPI.MFB1_0100__getINVLimitRanges({
        prod_id: this.nowProduct.prod_id,
        insured_actage: insured_actage,
        insured_age: this.MfEditing.insured.insured_age,
        insured_gender: this.MfEditing.insured.insured_gender,
      });
      this.amt_limit = amt_limit;
      this.prem_limit = prem_limit;
      this.initValidator();
    },
    async getINVPremiumLimitRanges() {
      if (this.getINVPremiumLimitTimer) {
        clearTimeout(this.getINVPremiumLimitTimer);
      }
      this.$store.commit("update_canSave", false);
      this.getINVPremiumLimitTimer = setTimeout(async () => {
        let vaild = await this.$validator.validate(`amt`);
        if (vaild) {
          let insured_actage = this.MfEditing.insured.insured_birthday
            ? moment().diff(
                moment(this.MfEditing.insured.insured_birthday),
                "years"
              )
            : this.MfEditing.insured.insured_age;
          let {
            prem_floor,
            prem_ceil,
          } = await this.$mfAPI.MFB1_0100__getINVPremiumLimitRanges({
            prod_id: this.nowProduct.prod_id,
            insured_actage: insured_actage,
            insured_age: this.MfEditing.insured.insured_age,
            insured_gender: this.MfEditing.insured.insured_gender,
            amt: this.productDataScope.amt,
          });

          this.yearPremiumLimit = {
            prem_floor,
            prem_ceil,
          };
        } else {
          this.yearPremiumLimit = null;
        }
      }, 500);
    },
    async getINVAmtLimitRanges() {
      if (this.getINVAmtLimitTimer) {
        clearTimeout(this.getINVAmtLimitTimer);
      }
      this.$store.commit("update_canSave", false);
      this.getINVAmtLimitTimer = setTimeout(async () => {
        let vaild = this.productDataScope.pol_premium
          ? await this.$validator.validate(`pol_premium`)
          : false;
        if (vaild) {
          let insured_actage = this.MfEditing.insured.insured_birthday
            ? moment().diff(
                moment(this.MfEditing.insured.insured_birthday),
                "years"
              )
            : this.MfEditing.insured.insured_age;
          let amt_limit = await this.$mfAPI.MFB1_0100__getINVAmtLimitRanges({
            prod_id: this.nowProduct.prod_id,
            insured_actage: insured_actage,
            insured_age: this.MfEditing.insured.insured_age,
            insured_gender: this.MfEditing.insured.insured_gender,
            premium: this.productDataScope.pol_premium,
            pay_freq: this.productDataScope.pay_freq,
          });
          this.amt_limit = amt_limit;
          if (
            parseInt(this.amt_limit.amt_floor) >
            parseInt(this.amt_limit.amt_ceil)
          ) {
            this.$mfNotice(
              "您輸入的保費依最低比率規範換算保額後，最低保額大於商品保額上限，請重新輸入較低保費。"
            );
            this.productDataScope.pol_premium = "";
            this.getINVLimitRanges();
          }
          setTimeout(() => {
            if (this.productDataScope.amt) {
              this.$validator.validate(`amt`);
            }
          }, 50);
        } else {
          this.$store.commit("update_canSave", true);
        }
      }, 500);
    },
    initValidator() {
      //繳至
      Validator.extend(`pol_endage`, {
        getMessage: "",
        validate: (value) => {
          let insured_age = parseInt(
            this.$store.getters.MfEditing.insured.insured_age
          );

          //區分法定年齡與保險年齡邏輯(2022/3/18新增 )
          let insured_actage = this.$store.getters.MfEditing.insured
            .insured_birthday
            ? parseInt(
                moment().diff(
                  moment(
                    this.$store.getters.MfEditing.insured.insured_birthday
                  ),
                  "years"
                )
              )
            : insured_age;
          let insured_age_floor =
            this.PRODUCT_FEATURE_DATA.age_floor_kind == "2"
              ? insured_actage
              : insured_age; //被保人年齡(檢核下限用，預設值:保險年齡)

          let insured_age_ceil =
            this.PRODUCT_FEATURE_DATA.age_ceil_kind == "2"
              ? insured_actage
              : insured_age; //被保人年齡(檢核下限用，預設值:保險年齡)

          let { age_ceil, age_floor } = this.PRODUCT_FEATURE_DATA;
          //判斷是否符合承保年齡上下限
          if (
            parseInt(age_ceil) < parseInt(insured_age_ceil) ||
            parseInt(age_floor) > parseInt(insured_age_floor)
          ) {
            return false;
          }
          //判斷繳至的年齡是否合法
          if (
            parseInt(value) > parseInt(this.PRODUCT_FEATURE_DATA.pay_prd - 1) ||
            parseInt(value) < parseInt(insured_age)
          ) {
            return false;
          }
          return true;
        },
      });
      Validator.extend(`amt`, {
        getMessage: "",
        validate: (value) => {
          let intValue = parseInt(value.split(",").join(""));
          //符合保額遞增與保額上下限
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.amt_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.amt_incr_unit / this.amt_formatVal;
          let ceil =
            this.amt_limit.amt_ceil <= 0 ? Infinity : this.amt_limit.amt_ceil;
          return (
            (!this.amt_limit ||
              (intValue <= ceil && intValue >= this.amt_limit.amt_floor)) &&
            intValue % incr_unit === 0
          );
        },
      });
      Validator.extend(`pol_premium`, {
        getMessage: "",
        validate: (value) => {
          if (!this.productDataScope.pay_freq) return false;
          let intValue = parseInt(value.split(",").join(""));
          //符合保費遞增與保額上下限
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
          let ceil =
            this.prem_limit[this.productDataScope.pay_freq].prem_ceil <= 0
              ? Infinity
              : this.prem_limit[this.productDataScope.pay_freq].prem_ceil;
          return (
            (!this.productDataScope.pay_freq ||
              (intValue <= ceil &&
                intValue >=
                  this.prem_limit[this.productDataScope.pay_freq]
                    .prem_floor)) &&
            intValue % incr_unit === 0
          );
        },
      });
    },
    converIncrUnit(number) {
      let face_prem_incr_unit =
        this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
          ? 1
          : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
      return Math.floor(number / face_prem_incr_unit) * face_prem_incr_unit;
    },
    resetPaymethod(dataID) {
      const messages = {
        pol_endage: {
          confirm:
            "修改目標保費繳至幾歲,若有輸入的超額保費將全部清除,是否仍要修改?",
        },
        amt: {
          confirm:
            "修改基本保額,若有輸入的基本保額調整將全部清除,是否仍要修改?",
        },
      };
      let paymethod = this.productDataScope.paymethod
        ? JSON.parse(this.productDataScope.paymethod)
        : [];
      let checkPaymethod = false;
      if (Object.keys(paymethod).length > 0) {
        switch (dataID) {
          case "pol_endage":
            checkPaymethod =
              paymethod.flexiblePrem.length > 0 ||
              paymethod.regularFlexiblePrem.length > 0;
            break;
          case "amt":
            checkPaymethod = paymethod.adjAmtFlexible.length > 0;
            break;
        }
      }
      if (checkPaymethod) {
        this.$mfNotice(
          messages[dataID].confirm,
          () => {
            switch (dataID) {
              case "pol_endage":
                if (this.productDataScope.temp__addPayment) {
                  this.productDataScope.temp__addPayment.regularFlexiblePrem = [];
                  this.productDataScope.temp__addPayment.flexiblePrem = [];
                }
                paymethod.regularFlexiblePrem = [];
                paymethod.flexiblePrem = [];
                break;
              case "amt":
                if (this.productDataScope.temp__addPayment) {
                  this.productDataScope.temp__addPayment.adjAmtFlexible = [];
                }
                paymethod.adjAmtFlexible = [];
                break;
            }
            this.productDataScope.paymethod = JSON.stringify(paymethod);
          },
          true,
          () => {
            const rollbackKey = `${dataID}_tmp`;
            if (this.productDataScope[rollbackKey]) {
              this.productDataScope[dataID] = this.productDataScope[
                rollbackKey
              ];
            }
            this.$validator.reset();
          },
          "確定清除"
        );
      }
    },
    async validateAll() {
      let VaildInput = await this.$validator.validateAll();
      return VaildInput;
    },
  },
  watch: {
    "productDataScope.amt": {
      handler() {
        if (!this.productDataScope.amt) return;
        this.getINVPremiumLimitRanges();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  margin-right: 8px !important;
  line-height: 40px;
  white-space: nowrap;
}
.yearPremiumLimit {
  display: inline-block;
  padding: 5px 10px 4px;
  background-color: #fff3c2;
  font-weight: 700;
}
</style>
